var map = {
	"./views/404": [
		75971,
		5971
	],
	"./views/404.vue": [
		75971,
		5971
	],
	"./views/AboutView": [
		55609,
		5609
	],
	"./views/AboutView.vue": [
		55609,
		5609
	],
	"./views/Billing": [
		19344,
		9344
	],
	"./views/Billing copy": [
		44019,
		4019
	],
	"./views/Billing copy.vue": [
		44019,
		4019
	],
	"./views/Billing.vue": [
		19344,
		9344
	],
	"./views/Dashboard": [
		83400,
		2022,
		9447,
		9930
	],
	"./views/Dashboard.vue": [
		83400,
		2022,
		9447,
		9930
	],
	"./views/HomeView": [
		55515,
		5515
	],
	"./views/HomeView.vue": [
		55515,
		5515
	],
	"./views/Layout": [
		40637,
		637
	],
	"./views/Layout.vue": [
		40637,
		637
	],
	"./views/Profile": [
		12436,
		2436
	],
	"./views/Profile.vue": [
		12436,
		2436
	],
	"./views/RTL": [
		22595,
		2022,
		9447,
		4385
	],
	"./views/RTL.vue": [
		22595,
		2022,
		9447,
		4385
	],
	"./views/Tables": [
		2422,
		2422
	],
	"./views/Tables.vue": [
		2422,
		2422
	],
	"./views/admin/blog/BlogCreate": [
		38434,
		8434
	],
	"./views/admin/blog/BlogCreate.vue": [
		38434,
		8434
	],
	"./views/admin/blog/BlogEdit": [
		94123,
		4123
	],
	"./views/admin/blog/BlogEdit.vue": [
		94123,
		4123
	],
	"./views/admin/blog/BlogList": [
		89616,
		5968,
		9017
	],
	"./views/admin/blog/BlogList.vue": [
		89616,
		5968,
		9017
	],
	"./views/admin/blog/BlogView": [
		78876,
		8876
	],
	"./views/admin/blog/BlogView.vue": [
		78876,
		8876
	],
	"./views/admin/categories/CategoriesCreate": [
		44931,
		4931
	],
	"./views/admin/categories/CategoriesCreate.vue": [
		44931,
		4931
	],
	"./views/admin/categories/CategoriesEdit": [
		57234,
		7234
	],
	"./views/admin/categories/CategoriesEdit.vue": [
		57234,
		7234
	],
	"./views/admin/categories/CategoriesList": [
		96209,
		5968,
		3746
	],
	"./views/admin/categories/CategoriesList.vue": [
		96209,
		5968,
		3746
	],
	"./views/admin/categories/CategoriesView": [
		52337,
		2337
	],
	"./views/admin/categories/CategoriesView.vue": [
		52337,
		2337
	],
	"./views/admin/customer/Customer": [
		5679,
		9711,
		4357,
		4135
	],
	"./views/admin/customer/Customer.vue": [
		5679,
		9711,
		4357,
		4135
	],
	"./views/admin/customer/component/CustomerCreate": [
		38288,
		9711,
		661
	],
	"./views/admin/customer/component/CustomerCreate.vue": [
		38288,
		9711,
		661
	],
	"./views/admin/customer/component/CustomerCreateForm": [
		69711,
		9711,
		9016
	],
	"./views/admin/customer/component/CustomerCreateForm.vue": [
		69711,
		9711,
		9016
	],
	"./views/admin/customer/component/ServiceBuy": [
		94357,
		9711,
		4357,
		645
	],
	"./views/admin/customer/component/ServiceBuy.vue": [
		94357,
		9711,
		4357,
		645
	],
	"./views/admin/customer/component/ServiceHostingList": [
		97419,
		9711,
		4357,
		6131
	],
	"./views/admin/customer/component/ServiceHostingList.vue": [
		97419,
		9711,
		4357,
		6131
	],
	"./views/admin/dasboard/Dasboard": [
		79990,
		2022,
		9990
	],
	"./views/admin/dasboard/Dasboard.vue": [
		79990,
		2022,
		9990
	],
	"./views/admin/expenditure/Expenditure": [
		28243,
		5968,
		2324
	],
	"./views/admin/expenditure/Expenditure.vue": [
		28243,
		5968,
		2324
	],
	"./views/admin/expenditure/component/ChangePassword": [
		32393,
		2393
	],
	"./views/admin/expenditure/component/ChangePassword.vue": [
		32393,
		2393
	],
	"./views/admin/expenditure/component/CreateUser": [
		42623,
		2623
	],
	"./views/admin/expenditure/component/CreateUser.vue": [
		42623,
		2623
	],
	"./views/admin/expenditure/component/EditUser": [
		19560,
		9560
	],
	"./views/admin/expenditure/component/EditUser.vue": [
		19560,
		9560
	],
	"./views/admin/news/NewsCreate": [
		63001,
		3001
	],
	"./views/admin/news/NewsCreate.vue": [
		63001,
		3001
	],
	"./views/admin/news/NewsEdit": [
		67426,
		7426
	],
	"./views/admin/news/NewsEdit.vue": [
		67426,
		7426
	],
	"./views/admin/news/NewsList": [
		35527,
		5968,
		3760
	],
	"./views/admin/news/NewsList.vue": [
		35527,
		5968,
		3760
	],
	"./views/admin/news/NewsView": [
		11811,
		1811
	],
	"./views/admin/news/NewsView.vue": [
		11811,
		1811
	],
	"./views/admin/product/ColorForm": [
		65958,
		5958
	],
	"./views/admin/product/ColorForm.vue": [
		65958,
		5958
	],
	"./views/admin/product/ProductCreate": [
		95196,
		5196
	],
	"./views/admin/product/ProductCreate.vue": [
		95196,
		5196
	],
	"./views/admin/product/ProductEdit": [
		42391,
		2391
	],
	"./views/admin/product/ProductEdit.vue": [
		42391,
		2391
	],
	"./views/admin/product/ProductList": [
		33219,
		5968,
		4004
	],
	"./views/admin/product/ProductList.vue": [
		33219,
		5968,
		4004
	],
	"./views/admin/product/ProductView": [
		56768,
		6768
	],
	"./views/admin/product/ProductView.vue": [
		56768,
		6768
	],
	"./views/admin/revenue/Revenue": [
		92838,
		5968,
		2639
	],
	"./views/admin/revenue/Revenue.vue": [
		92838,
		5968,
		2639
	],
	"./views/admin/revenue/component/ChangePassword": [
		47064,
		7064
	],
	"./views/admin/revenue/component/ChangePassword.vue": [
		47064,
		7064
	],
	"./views/admin/revenue/component/CreateUser": [
		76621,
		6621
	],
	"./views/admin/revenue/component/CreateUser.vue": [
		76621,
		6621
	],
	"./views/admin/revenue/component/EditUser": [
		81717,
		1717
	],
	"./views/admin/revenue/component/EditUser.vue": [
		81717,
		1717
	],
	"./views/admin/user/UserInform": [
		68670,
		8670
	],
	"./views/admin/user/UserInform.vue": [
		68670,
		8670
	],
	"./views/admin/user/UserList": [
		92849,
		5968,
		8770
	],
	"./views/admin/user/UserList.vue": [
		92849,
		5968,
		8770
	],
	"./views/admin/user/component/ChangePassword": [
		34422,
		4422
	],
	"./views/admin/user/component/ChangePassword.vue": [
		34422,
		4422
	],
	"./views/admin/user/component/CreateUser": [
		67233,
		7233
	],
	"./views/admin/user/component/CreateUser.vue": [
		67233,
		7233
	],
	"./views/admin/user/component/EditUser": [
		10277,
		277
	],
	"./views/admin/user/component/EditUser.vue": [
		10277,
		277
	],
	"./views/client/about/About": [
		87743,
		7743
	],
	"./views/client/about/About.vue": [
		87743,
		7743
	],
	"./views/client/blog/Blog": [
		70950,
		950
	],
	"./views/client/blog/Blog.vue": [
		70950,
		950
	],
	"./views/client/cart/Cart": [
		89143,
		9143
	],
	"./views/client/cart/Cart.vue": [
		89143,
		9143
	],
	"./views/client/cart/CartMenu": [
		85827
	],
	"./views/client/cart/CartMenu.vue": [
		85827
	],
	"./views/client/cart/CartSubmit": [
		55404,
		5404
	],
	"./views/client/cart/CartSubmit.vue": [
		55404,
		5404
	],
	"./views/client/cart/CartSupport": [
		52817,
		2817
	],
	"./views/client/cart/CartSupport.vue": [
		52817,
		2817
	],
	"./views/client/collections/Collections": [
		99070,
		9070
	],
	"./views/client/collections/Collections.vue": [
		99070,
		9070
	],
	"./views/client/collections/CollectionsItems": [
		84448,
		4448
	],
	"./views/client/collections/CollectionsItems.vue": [
		84448,
		4448
	],
	"./views/client/collections/Collections_page": [
		57962,
		7962
	],
	"./views/client/collections/Collections_page.vue": [
		57962,
		7962
	],
	"./views/client/collections/HomeCollection": [
		9346,
		9346
	],
	"./views/client/collections/HomeCollection.vue": [
		9346,
		9346
	],
	"./views/client/contact/Contact": [
		60286,
		286
	],
	"./views/client/contact/Contact.vue": [
		60286,
		286
	],
	"./views/client/contact/Maps": [
		66250,
		6250
	],
	"./views/client/contact/Maps.vue": [
		66250,
		6250
	],
	"./views/client/favourite/Favourite": [
		58934,
		8387,
		9035
	],
	"./views/client/favourite/Favourite.vue": [
		58934,
		8387,
		9035
	],
	"./views/client/google/GoogleMap": [
		4375,
		4375
	],
	"./views/client/google/GoogleMap.vue": [
		4375,
		4375
	],
	"./views/client/home/BannerSloganSeller": [
		23724,
		8834
	],
	"./views/client/home/BannerSloganSeller.vue": [
		23724,
		8834
	],
	"./views/client/home/CategoryBanner": [
		51417,
		1417
	],
	"./views/client/home/CategoryBanner.vue": [
		51417,
		1417
	],
	"./views/client/home/Home": [
		43601,
		8387,
		4686
	],
	"./views/client/home/Home.vue": [
		43601,
		8387,
		4686
	],
	"./views/client/home/child/FeaturedProducts": [
		76889,
		8387,
		5974
	],
	"./views/client/home/child/FeaturedProducts.vue": [
		76889,
		8387,
		5974
	],
	"./views/client/login/lock/LockScreen": [
		20987,
		987
	],
	"./views/client/login/lock/LockScreen.vue": [
		20987,
		987
	],
	"./views/client/login/password/ForgotPassword": [
		82490,
		2490
	],
	"./views/client/login/password/ForgotPassword.vue": [
		82490,
		2490
	],
	"./views/client/login/signin/Login": [
		38607,
		8607
	],
	"./views/client/login/signin/Login copy": [
		20527,
		527
	],
	"./views/client/login/signin/Login copy.vue": [
		20527,
		527
	],
	"./views/client/login/signin/Login.vue": [
		38607,
		8607
	],
	"./views/client/login/signin/login.css": [
		50054,
		54
	],
	"./views/client/login/signup/FaceBookRegister": [
		53024,
		3024
	],
	"./views/client/login/signup/FaceBookRegister.vue": [
		53024,
		3024
	],
	"./views/client/login/signup/GoogleRegister": [
		20730,
		730
	],
	"./views/client/login/signup/GoogleRegister.vue": [
		20730,
		730
	],
	"./views/client/login/signup/RegisterForm": [
		27290,
		7290
	],
	"./views/client/login/signup/RegisterForm copy": [
		10639,
		639
	],
	"./views/client/login/signup/RegisterForm copy.vue": [
		10639,
		639
	],
	"./views/client/login/signup/RegisterForm.vue": [
		27290,
		7290
	],
	"./views/client/login/signup/TelegramRegister": [
		72357,
		2357
	],
	"./views/client/login/signup/TelegramRegister.vue": [
		72357,
		2357
	],
	"./views/client/news/News": [
		38660,
		8660
	],
	"./views/client/news/News.vue": [
		38660,
		8660
	],
	"./views/client/news/NewsDetails": [
		54538,
		4538
	],
	"./views/client/news/NewsDetails.vue": [
		54538,
		4538
	],
	"./views/client/news/NewsICategory": [
		25142,
		5142
	],
	"./views/client/news/NewsICategory.vue": [
		25142,
		5142
	],
	"./views/client/news/NewsItem": [
		13373,
		3373
	],
	"./views/client/news/NewsItem.vue": [
		13373,
		3373
	],
	"./views/client/news/NewsTop3": [
		76776,
		6776
	],
	"./views/client/news/NewsTop3.vue": [
		76776,
		6776
	],
	"./views/client/news/TopView": [
		15990,
		5990
	],
	"./views/client/news/TopView.vue": [
		15990,
		5990
	],
	"./views/client/orders/Orders": [
		35644,
		5644
	],
	"./views/client/orders/Orders.vue": [
		35644,
		5644
	],
	"./views/client/portfolio/Portfolio": [
		8686,
		4864,
		7067
	],
	"./views/client/portfolio/Portfolio.vue": [
		8686,
		4864,
		7067
	],
	"./views/client/portfolio/PortfolioItems": [
		7803,
		7803
	],
	"./views/client/portfolio/PortfolioItems.vue": [
		7803,
		7803
	],
	"./views/client/pricing/Pricing": [
		9094,
		9094
	],
	"./views/client/pricing/Pricing.vue": [
		9094,
		9094
	],
	"./views/client/product/ProductDetails": [
		76641,
		8387,
		6606
	],
	"./views/client/product/ProductDetails.vue": [
		76641,
		8387,
		6606
	],
	"./views/client/product/ProductList": [
		47745,
		7745
	],
	"./views/client/product/ProductList.vue": [
		47745,
		7745
	],
	"./views/client/product/Products": [
		70567,
		8387,
		4864,
		9443
	],
	"./views/client/product/Products.vue": [
		70567,
		8387,
		4864,
		9443
	],
	"./views/client/product/common/DetailColor": [
		35400,
		5400
	],
	"./views/client/product/common/DetailColor.vue": [
		35400,
		5400
	],
	"./views/client/product/common/DetailGallery": [
		2009,
		2009
	],
	"./views/client/product/common/DetailGallery.vue": [
		2009,
		2009
	],
	"./views/client/product/common/DetailSize": [
		49025,
		9025
	],
	"./views/client/product/common/DetailSize.vue": [
		49025,
		9025
	],
	"./views/client/product/common/DetailStyle": [
		69978,
		9978
	],
	"./views/client/product/common/DetailStyle.vue": [
		69978,
		9978
	],
	"./views/client/product/common/HeaderCategory": [
		33230,
		3230
	],
	"./views/client/product/common/HeaderCategory.vue": [
		33230,
		3230
	],
	"./views/client/product/common/MarkPrice": [
		49957,
		9957
	],
	"./views/client/product/common/MarkPrice.vue": [
		49957,
		9957
	],
	"./views/client/product/common/ProductItems": [
		48387,
		8387,
		7198
	],
	"./views/client/product/common/ProductItems.vue": [
		48387,
		8387,
		7198
	],
	"./views/client/product/common/RelatedProducts": [
		83351,
		8387,
		952
	],
	"./views/client/product/common/RelatedProducts.vue": [
		83351,
		8387,
		952
	],
	"./views/client/product/common/SelectProduct": [
		24803,
		4803
	],
	"./views/client/product/common/SelectProduct.vue": [
		24803,
		4803
	],
	"./views/client/product/common/SlideProducts": [
		85340,
		5340
	],
	"./views/client/product/common/SlideProducts.vue": [
		85340,
		5340
	],
	"./views/client/product/common/ViewedProducts": [
		17344,
		8387,
		9593
	],
	"./views/client/product/common/ViewedProducts.vue": [
		17344,
		8387,
		9593
	],
	"./views/client/profile/Profile": [
		16452,
		6452
	],
	"./views/client/profile/Profile.vue": [
		16452,
		6452
	],
	"./views/client/service/Service": [
		92438,
		2438
	],
	"./views/client/service/Service.vue": [
		92438,
		2438
	],
	"./views/client/user/Profile": [
		22866,
		2866
	],
	"./views/client/user/Profile.vue": [
		22866,
		2866
	],
	"./views/demo/KeycloakToken": [
		41265,
		1265
	],
	"./views/demo/KeycloakToken.vue": [
		41265,
		1265
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 55378;
module.exports = webpackAsyncContext;